import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-sm text-foreground-500">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={index} className="flex items-center gap-1.5">
            {index > 0 && (
              <span className="w-3 h-3 flex items-center justify-center">
                <i className="ri-arrow-right-s-line text-xs"></i>
              </span>
            )}
            {isLast || !item.to ? (
              <span className={isLast ? 'text-foreground-900 font-medium' : ''}>
                {item.label}
              </span>
            ) : (
              <Link
                to={item.to}
                className="hover:text-primary-500 transition-colors cursor-pointer"
              >
                {item.label}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}